import { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useNavigate } from 'react-router-dom';
import Layout from './Layout';
import Login from './pages/Login/Login';
import AdminDashboard from './pages/AdminDashboard/AdminDashboard';
import Profile from './pages/Profile/Profile';
import Resume from './pages/Resume/Resume';
import UserManagement from './pages/UserManagement/UserManagement';
import ResumeManagement from './pages/ResumeManagement/ResumeManagement';
import SendOTP from './pages/SendOTP/SendOTP';
import CheckOTP from './pages/CheckOTP/CheckOTP';
import UserDashboard from './pages/UserDashboard/UserDashboard';
import UserRegister from './pages/UserRegister/UserRegister';
import ChangePassword from './pages/ChangePassword/ChangePassword';
import RestorePassword from './pages/RestorePassword/RestorePassword';
import AddActivity from './pages/AddActivity/AddActivity';
import NotFound from './pages/NotFound/NotFound';
// import ServerError from './pages/server_error/server_error';
import Unauthorized from './pages/Unauthorized/Unauthorized';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute/ProtectedRoute';
import PublicRoute from './components/PublicRoute/PublicRoute';
import Home from './pages/Home/Home';
import ProfessorProfile from './pages/ProfessorProfile/ProfessorProfile';
import Callback from './pages/Callback/Callback';

const App = () => {
    const navigate = useNavigate();

    useEffect(() => {
        if (!sessionStorage.getItem('sessionActive')) {
            localStorage.removeItem('token');
            localStorage.removeItem('role');
            localStorage.setItem('is_authenticated', 'false');
            sessionStorage.setItem('sessionActive', 'true');
            navigate('/home');
        }
    }, []);

    return (
        <>
            <AuthProvider>
                <Routes>
                    <Route element={<PublicRoute />}>
                        <Route path='/' element={<Navigate to='/home' />} />
                        <Route path='/login' element={<Login />} />
                        <Route path='/callback' element={<Callback />} />
                        <Route path='/home' element={<Home />} />
                        <Route path='/home/professor-profile/:id' element={<ProfessorProfile/>} />
                        <Route path='/send-otp' element={<Layout><SendOTP /></Layout>} />
                        <Route path='/check-otp' element={<Layout><CheckOTP /></Layout>} />
                        <Route path='/restore-password' element={<Layout><RestorePassword /></Layout>} />
                    </Route>
                    <Route path='*' element={<NotFound />} />
                    <Route path='/unauthorized' element={<Unauthorized />} />
                    {/* Admin Section */}
                    <Route element={<ProtectedRoute requiredRole='admin' />}>
                        <Route path='/admin/dashboard' element={<Layout><AdminDashboard /></Layout>} />
                        <Route path='/admin/add-user' element={<Layout><UserRegister /></Layout>} />
                        <Route path='/admin/user-management' element={<Layout><UserManagement /></Layout>} />
                        <Route path='/admin/user-management/profile/:id' element={<Layout><Profile /></Layout>} />
                        <Route path='/admin/user-management/activities/:id' element={<Layout><ResumeManagement /></Layout>} />
                        <Route path='/admin/user-management/activities/resume/:id' element={<Layout><Resume /></Layout>} />
                        <Route path='/admin/user-management/activities/add-activity/:id' element={<Layout><AddActivity /></Layout>} />
                        <Route path='/admin/change-password' element={<Layout><ChangePassword /></Layout>} />
                    </Route>
                    {/* User Section */}
                    <Route element={<ProtectedRoute requiredRole='user' />}>
                        <Route path='/user/profile' element={<Layout><Profile /></Layout>} />
                        <Route path='/user/activities' element={<Layout><ResumeManagement /></Layout>} />
                        <Route path='/user/activities/resume/:id' element={<Layout><Resume /></Layout>} />
                        <Route path='/user/activities/add-activity' element={<Layout><AddActivity /></Layout>} />
                        <Route path='/user/dashboard' element={<Layout><UserDashboard /></Layout>} />
                        <Route path='/user/change-password' element={<Layout><ChangePassword /></Layout>} />
                    </Route>
                </Routes>
                    {/* <Switch>
            <Route path='/server-error' component={ServerError} />
            <Route render={() => <ServerError />} />
        </Switch> */}
            </AuthProvider>
        </>
    );
};

export default App;
